import { Resizable } from 're-resizable'
import { useState } from 'react'

import { Box } from '../ui'

type Props = {
  mainContent: React.ReactNode
  resizableContent: React.ReactNode
}

// NOTE: 左側をメインコンテンツ、右側をリサイズ可能なコンテンツとして表示するレイアウト (試験一覧+問い合わせ一覧など)
export const ResizableLayout = ({ mainContent, resizableContent }: Props) => {
  const [resizableWidth, setResizableWidth] = useState(400)

  return (
    <Box display="flex" w="full" h="full" overflow="hidden">
      <Box flex={1} h="full" overflow="auto">
        {mainContent}
      </Box>

      <Resizable
        enable={{ left: true }}
        size={{
          width: resizableWidth,
        }}
        onResizeStop={(_, __, ___, d) =>
          setResizableWidth(prevWidth => prevWidth + d.width)
        }
        minWidth={318}
        maxWidth={600}
      >
        {resizableContent}
      </Resizable>
    </Box>
  )
}
